<template>
  <!-- header here -->
  <header class="sticky-header">
    <header-top-vue />
    <div class="calc-new-header calc-appoitment">
      <div
        class="float-right header-icon-contain position-relative col-12-custom canel-add-icon"
      >
        <div class="d-inline float-left">
          <a href="#" class="color-red" @click.stop.prevent="$router.go(-1)"
            >Cancel</a
          >
        </div>
        <div class="d-inline float-right">
          <a href="#" class="color-red" @click.stop.prevent="showPopupLocal"
            >Save</a
          >
        </div>
      </div>
    </div>
  </header>
  <!-- header ends here -->
</template>

<script>
import HeaderTopVue from "../../common/HeaderTop.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: {
    HeaderTopVue
  },
  computed: {
    ...mapGetters("person", {
      validated: "getValidated"
    })
  },
  methods: {
    ...mapMutations("person", {
      setValidated: "setValidated"
    }),
    ...mapActions("person", {
      validate: "validate"
    }),
    showPopupLocal() {
      this.validate();
    }
  },
  props: {
    showPopup: Function
  },
  watch: {
    validated(value) {
      if (value) {
        this.showPopup();
        this.setValidated(false);
      }
    }
  }
};
</script>

<style scoped>
/*--.calc-new-header {
  width: calc(100vw - 30px) !important;
}--*/
</style>
